// 开学抽签页面
const fondOfLearningDrawLots = () => import('@/pages/activity/fondOfLearningDrawLots/index.vue');
const fondOfLearningDrawResult = () => import('@/pages/activity/fondOfLearningDrawLots/drawResult.vue');
const flashKillListResult = () => import('@/pages/flashKillList/index.vue');
const schoolChoose = () => import('@/pages/schoolChoose/index.vue');
const schoolChooseSubmit = () => import('@/pages/schoolChoose/submit.vue');
const schoolChooseHasFinish = () => import('@/pages/schoolChoose/finished.vue');

const stressTest = () => import('@/pages/activity/stressTest/index.vue');
const stressTestanswer = () => import('@/pages/activity/stressTest/answer.vue');
const stressAnswer = () => import('@/pages/activity/stressTest/testResult.vue');

const questionLottery = () => import('@/pages/activity/questionLottery/index.vue');
const tempAdress = () => import('@/pages/activity/questionLottery/adress.vue');
// 活动页
export default [
  {
    path: '/seconDkill',
    component: () => import('@/pages/activity/seconDkill.vue'),
  },
  {
    path: '/drawLots',
    component: fondOfLearningDrawLots,
    meta: {
      title: '抽签活动',
    },
  },
  {
    path: '/drawResult',
    component: fondOfLearningDrawResult,
    meta: {
      title: '创意物料',
      requireAuth: true,
    },
  },
  {
    path: '/flashKill',
    component: flashKillListResult,
    meta: {
      title: '秒杀活动列表',
      keepAlive: true,
    },
  },
  {
    path: '/schoolChoose',
    component: schoolChoose,
    meta: {
      title: '1对1择校',
      keepAlive: true,
    },
  },
  {
    path: '/schoolChoose/submit',
    component: schoolChooseSubmit,
    meta: {
      title: '1对1择校',
      keepAlive: true,
    },
  },
  {
    path: '/schoolChoose/finished',
    component: schoolChooseHasFinish,
    meta: {
      title: '1对1择校',
      keepAlive: true,
    },
  },
  {
    path: '/stresstest',
    component: stressTest,
    meta: {
      title: '压力测试',
    },
  },
  {
    path: '/answer',
    component: stressTestanswer,
    meta: {
      title: '',
      keepAlive: false,
    },
  },
  {
    path: '/result',
    component: stressAnswer,
    meta: {
      title: '',
      keepAlive: false,
    },
  },
  {
    path: '/questionlottery',
    component: questionLottery,
    meta: {
      title: '',
      keepAlive: false,
    },
  },
  {
    path: '/tempadress',
    component: tempAdress,
    meta: {
      title: '',
      keepAlive: false,
    },
  },

];
